(function () {
    'use strict';

    a3_cabin_reports.directive('jumpseatRequestRow', jumpseatRequestRow);

    /**
     * @memberof CabinReports
     * @ngdoc directive
     * @name jumpseatRequestRow
     * @description
     *   Renders one jumpseat request row content for submitted/acknowledge panels.
     */
    function jumpseatRequestRow() {
        /**
         * Initialize directive state and helper methods.
         * @param {object} scope directive scope
         * @param {object} element directive element
         * @param {object} attrs directive attributes
         */
        function link(scope, element, attrs) {
            scope.isAcknowledge = false; //only for CP 
            scope.passengerRows = [];
            scope.getStatusLabel = getStatusLabel;
            scope.getStatusTextClass = getStatusTextClass;
            scope.getStatusBorderClass = getStatusBorderClass;
            scope.isGeneralDeclarationRequest = isGeneralDeclarationRequest;
            scope.handleCancel = handleCancel;
            scope.travelersCounter = 0;

            scope.$watchGroup(['request', 'crewInfo', 'ancillaries', 'isAcknowledge'], rebuildPassengerRows);

            /**
             * Rebuild passenger rows when request data changes.
             */
            function rebuildPassengerRows() {
                scope.passengerRows = buildPassengerRows(scope.request, scope.crewInfo);
            }

            /**
             * Resolve status label from ancillaries or fallback map.
             * @param {number} statusValue request status value
             * @returns {string} display label
             */
            function getStatusLabel(statusValue) {
                var statuses = scope.ancillaries && scope.ancillaries.Statuses
                    ? scope.ancillaries.Statuses
                    : null;
                var index;

                if (statuses && statuses.length) {
                    for (index = 0; index < statuses.length; index += 1) {
                        if (statuses[index].id === statusValue || statuses[index].value === statusValue) {
                            return statuses[index].text || statuses[index].label;
                        }
                    }
                }

                if (statusValue === 1) {
                    return 'Pending';
                }

                if (statusValue === 2) {
                    return 'Accepted';
                }

                if (statusValue === 3) {
                    return 'Rejected';
                }

                return 'Unknown';
            }

            /**
             * Map status to a text color css class.
             * @param {number} statusValue request status value
             * @returns {string} css class name
             */
            function getStatusTextClass(statusValue) {
                if (statusValue === 2) {
                    return 'text-green';
                }

                if (statusValue === 3) {
                    return 'text-red';
                }

                return 'text-blue';
            }

            /**
             * Map status to a left-border css class.
             * @param {number} statusValue request status value
             * @returns {string} css class name
             */
            function getStatusBorderClass(statusValue) {
                if (statusValue === 2) {
                    return 'border-left-green';
                }

                if (statusValue === 3) {
                    return 'border-left-red';
                }

                return 'border-left-blue';
            }

            /**
             * Check whether request type is General Declaration.
             * @param {number} requestType request type value
             * @returns {boolean} true for General Declaration
             */
            function isGeneralDeclarationRequest(requestType) {
                return requestType === 2;
            }

            /**
             * Invoke cancel callback when provided.
             */
            function handleCancel() {
                if (attrs.onCancel) {
                    scope.onCancel({ requestId: scope.request.RequestId });
                }
            }

            /**
             * Invoke accept callback when provided.
             */
            function handleAccept() {
                if (attrs.onAccept) {
                    scope.onAccept({ requestId: scope.request.RequestId });
                }
            }

            /**
             * Invoke reject callback when provided.
             */
            function handleReject() {
                if (attrs.onReject) {
                    scope.onReject({ requestId: scope.request.RequestId });
                }
            }

            /**
             * Build passenger rows based on TravelersType rules.
             * @param {object} request request object
             * @param {object} crewInfo crew info object
             * @returns {array} normalized passenger rows
             */
            function buildPassengerRows(request, crewInfo) {
                var passengers = request && request.Passengers ? request.Passengers : [];
                var rows = [];
                var crewName = crewInfo && crewInfo.Name ? crewInfo.Name : '';
                var index;

                if (request.TravelersType === 1) {
                    scope.travelersCounter = 1;
                      rows.push({
                        Name: crewName,
                        Relationship: '',
                        IsSelf: true
                    });
                    return rows;
                }

                if (request.TravelersType === 2) {
                    for (index = 0; index < passengers.length; index += 1) {
                        rows.push(normalizePassenger(passengers[index]));
                    }
                    scope.travelersCounter = passengers.length;
                    return rows;
                }

                if (request.TravelersType === 3) {
                    rows.push({
                        Name: crewName,
                        Relationship: '',
                        IsSelf: true
                    });

                    for (index = 0; index < passengers.length; index += 1) {
                        if (passengers[index].Relationship === 'Self' || passengers[index].Name === crewName) {
                            continue;
                        }

                        rows.push(normalizePassenger(passengers[index]));
                    }
                    scope.travelersCounter = rows.length;
                }

                return rows;
            }

            /**
             * Convert passenger relationship id to display text from ancillaries.
             * @param {object} passenger passenger object from API
             * @returns {object} normalized passenger object for UI
             */
            function normalizePassenger(passenger) {
                return {
                    Name: passenger && passenger.Name ? passenger.Name : '',
                    Relationship: getRelationshipText(passenger ? passenger.Relationship : null),
                    IsSelf: passenger && passenger.IsSelf === true
                };
            }

            /**
             * Resolve relationship label from ancillaries by id.
             * @param {number|string} relationship relationship id or text
             * @returns {string} relationship display text
             */
            function getRelationshipText(relationship) {
                var relationships = scope.ancillaries && scope.ancillaries.PassengerRelationships
                    ? scope.ancillaries.PassengerRelationships
                    : [];
                var index;

                if (relationship === null || relationship === undefined) {
                    return '';
                }

                if (typeof relationship === 'string') {
                    return relationship;
                }

                for (index = 0; index < relationships.length; index += 1) {
                    if (relationships[index].id === relationship || relationships[index].value === relationship) {
                        return relationships[index].text || relationships[index].label || '';
                    }
                }

                return '';
            }
        }

        return {
            restrict: 'E',
            templateUrl: 'views/JumpseatRequests/requestRow.tpl.html',
            scope: {
                request: '=',
                crewInfo: '=',
                ancillaries: '=',
                isAcknowledge: '=?',
                onCancel: '&',
                onAccept: '&',
                onReject: '&'
            },
            link: link
        };
    }
})();